import React, {Component} from 'react';
import {Redirect,Link} from 'react-router-dom'
import {message,PageHeader,Button,Modal,Form,Input,Select,Descriptions,Tag,Comment,Breadcrumb} from 'antd';
import {ExclamationCircleOutlined,CloseOutlined,PlusOutlined,UserOutlined} from '@ant-design/icons';
// import zhCN from 'antd/es/locale/zh_CN';
import reqwest from 'reqwest'
import moment from 'moment'; 
// import Highlighter from 'react-highlight-words';
import {Header} from '../Header.jsx'
import {Footer} from '../Footer.jsx'
import Nav from './Nav.jsx'
import {CheckLogin} from '../Common.jsx'
import BuildTitle from '../BuildTitle.jsx'

moment.locale('zh-cn');



export default class Variant extends Component {
	constructor(props) {
	    super(props);
		let token = '';
		let user_name = '';
		let role = '';
		let check_result = CheckLogin();
		if (check_result !== false){
			token = check_result.Authorization;
	    	user_name = check_result.user_name;
	    	role = check_result.role;
		}
		this.state = {
			...props,
			'L1': 'crog',
			'L2' : 'variants',
			'token' : token,
			'user_name': user_name,
			'role': role,
			'redirect' : '',
			'pubvar_id' : props.match.params.pubvar_id,
			'variant': {},
			'loading': true,
		}
	}
	componentDidMount(){
		if(this.state.token){
			this.fetch();
		}
	}


	fetch = () => {
		reqwest({
			url: `/api/crog/variant/${this.state.pubvar_id}`,
			method: 'GET',
			headers: {
				'Authorization': this.state.token,
			},
			type: 'json',
		}).then(
			(data) => {
				if(data.status === 1){
					this.setState({
						'loading': false,
						'variant': data.result,
					})
				}else{
					message.error(data.msg);
					this.setState({
						'loading': false,
					})
				}
			},
			(err,data) => {
				if(err.response === 'Unauthorized.'){
					console.log('Token invalid');
					localStorage.removeItem('Authorization');
					this.setState({
						'redirect': '/login'
					})
					message.error('登录失效');
					return false;
				}
				message.error('Network error');
				this.setState({'loading': false})
			}
		);
	}

	

	status_view = () => {
		let status = this.state.hpo['status'];
		if(!status){
			return ''
		}
		if(status === 1){ return '未校对';}
		if(status === 2){ return '校对中';}
		if(status === 3){ return '完成校对';}
		if(status === 4){ return '评审通过';}
		if(status === 9){ return '已废弃';}
		return status;
	}


	// 关键字的添加
	removeKey = (key) => {
		let that = this;
		Modal.confirm({
			title: '您确信要删除该标签?',
			icon: <ExclamationCircleOutlined />,
			onOk() {
				that.postKeyRemove(key);
			},
		});
		return false;
	}
	postKeyRemove = (key) => {
		reqwest({
			url: `/api/crog/variant/${this.state.pubvar_id}/key`,
			method: 'DELETE',
			headers: {
				'Authorization': this.state.token,
			},
			type: 'json',
			data: {'key' : key}
		}).then(
			(data) => {
				if(data.status === 1){
					message.success('添加成功');
					this.fetch()
				}else{
					message.error(data.msg);
					this.setState({
						'loading': false,
					})
				}
			},
			(err,data) => {
				if(err.response === 'Unauthorized.'){
					console.log('Token invalid');
					localStorage.removeItem('Authorization');
					this.setState({
						'redirect': '/login'
					})
					message.error('登录失效');
					return false;
				}
				message.error('Network error');
				this.setState({'loading': false})
			}
		);
	}
	showInput2 = () =>{
		this.setState({
			'key_input': true
		}, () => {
			this.refs.key_input.focus()
		})
	}
	addNewKey = (e) => {
		let value = e.target.value;
		if(!value){
			message.error('请输入基因别名');
			return true;
		}
		if(this.state.hpo['keys'].indexOf(value) !== -1){
			message.error('您输入的关键字已经存在');
			return true;
		}
		reqwest({
			url: `/api/crog/variant/${this.state.pubvar_id}/key`,
			method: 'POST',
			headers: {
				'Authorization': this.state.token,
			},
			type: 'json',
			data: {'key' : value}
		}).then(
			(data) => {
				if(data.status === 1){
					message.success('添加成功');
					this.fetch()
					this.setState({'key_input': false})
				}else{
					message.error(data.msg);
					this.setState({
						'loading': false,
					})
				}
			},
			(err,data) => {
				if(err.response === 'Unauthorized.'){
					console.log('Token invalid');
					localStorage.removeItem('Authorization');
					this.setState({
						'redirect': '/login'
					})
					message.error('登录失效');
					return false;
				}
				message.error('Network error');
				this.setState({'loading': false})
			}
		);
	}


	
	// 添加评论
	openCommentModal = () => {
		this.setState({'add_comment_modal': true});
	}
	closeCommentModal = () => {
		this.setState({'add_comment_modal': false});
	}
	addComment = () => {
		let form =this.refs.add_comment;
		let that = this;
		form.validateFields().then((data) => {
			if(! data['comment']){
				message.error('请输入评论');
				return false;
			}

			reqwest({
				url: `/api/crog/variant/${that.state.pubvar_id}/comment`,
				method: 'POST',
				headers: {
					'Authorization': that.state.token,
				},
				type: 'json',
				data: data
			}).then(
				(data) => {
					if(data.status === 1){
						message.success('添加成功');
						that.fetch()
						that.setState({'add_comment_modal': false})
					}else{
						message.error(data.msg);
						that.setState({
							'loading': false,
						})
					}
				},
				(err,data) => {
					if(err.response === 'Unauthorized.'){
						console.log('Token invalid');
						localStorage.removeItem('Authorization');
						that.setState({
							'redirect': '/login'
						})
						message.error('登录失效');
						return false;
					}
					message.error('Network error');
					that.setState({'loading': false})
				}
			);


		})
	}


	
	// 修改记录状态
	changeState = (value) => {
		reqwest({
			url: `/api/crog/variant/${this.state.pubvar_id}/status`,
			method: 'PATCH',
			headers: {
				'Authorization': this.state.token,
			},
			type: 'json',
			data: {'status': value}
		}).then(
			(data) => {
				if(data.status === 1){
					message.success('修改成功');
					this.fetch()
				}else{
					message.error(data.msg);
					this.setState({
						'loading': false,
					})
				}
			},
			(err,data) => {
				if(err.response === 'Unauthorized.'){
					console.log('Token invalid');
					localStorage.removeItem('Authorization');
					this.setState({
						'redirect': '/login'
					})
					message.error('登录失效');
					return false;
				}
				message.error('Network error');
				this.setState({'loading': false})
			}
		);
	}


	
	

	
	render(){
		if(! this.state.token){
			return <Redirect to="/login"/>
		}
		if(this.state.redirect){
			return <Redirect to={this.state.redirect}/>
		}
		return (
			<div>
				<Header {...this.state} />
				<div className="max-width">
					<Nav L2={this.state.L2} />
					<Breadcrumb style={{'marginTop':'9px'}}>
						<Breadcrumb.Item><Link to="/">Home</Link></Breadcrumb.Item>
						<Breadcrumb.Item><Link to={`/crog/variants`}>变异列表</Link></Breadcrumb.Item>
						<Breadcrumb.Item>{this.state.pubvar_id}</Breadcrumb.Item>
					</Breadcrumb>
					<PageHeader title={this.state.pubvar_id+' ('+this.state.variant['hg19_name']+')'} style={{padding:0,marginTop:10}} >
						<Descriptions size="small" column={3}  style={{'width':'800px'}}>
	        				<Descriptions.Item label="创建时间">{this.state.variant['date_created']} </Descriptions.Item>
	        				<Descriptions.Item label="最后修改">{this.state.variant['date_last_update']} </Descriptions.Item>
	        				<Descriptions.Item label="状态">
	        					<Select bordered={false} 
	        						size="small"
	        						onChange={this.changeState}
	        						value={ this.state.variant['status'] ? this.state.variant['status'].toString() : ''}
	        						style={{'width':'100px'}}
	        					>
	        						<Select.Option value="1">未校对</Select.Option>
	        						<Select.Option value="2">校对中</Select.Option>
	        						<Select.Option value="3">完成校对</Select.Option>
	        						<Select.Option value="4">评审通过</Select.Option>
	        						<Select.Option value="9">已废弃</Select.Option>
	        					</Select>
	        				</Descriptions.Item>
	        			</Descriptions>
					</PageHeader>

					<PageHeader title="基本信息" style={{paddingLeft:0,paddingRight:0}} 
					>
						<Descriptions size="small" column={1} bordered className="table_list2">
	        				<Descriptions.Item label="Hg19 name">{this.state.variant['hg19_name']} </Descriptions.Item>
	        				<Descriptions.Item label="Pubvar ID">{this.state.pubvar_id} </Descriptions.Item>
	        				<Descriptions.Item label="alleles">{this.state.variant['ref']}/{this.state.variant['alt']} </Descriptions.Item>
	        				<Descriptions.Item label="HGVS">{
	        					this.state.variant['pubvar'] ? (this.state.variant['pubvar']['HGVS'].map((item,index) => {
	        						return <div key={index}>{item}</div>
	        					})): ''} </Descriptions.Item>
	        				<Descriptions.Item label="疾病symbol"> </Descriptions.Item>
	        				<Descriptions.Item label="Inheritance">{this.state.variant['inheritance']} </Descriptions.Item>
	        			</Descriptions>
	        		</PageHeader>
	        		<PageHeader title="关键字" style={{paddingLeft:0,paddingRight:0}} >
						{
							this.state.variant['keys'] ?  this.state.variant['keys'].map((item,index) => {
								return <Tag key={item} >{item}  <CloseOutlined onClick={e => this.removeKey(item)} /></Tag>
							}) : ''
						}
						
						{
							this.state.key_input ? (
								<Input size="small" className="tag-input" ref="key_input" onPressEnter={this.addNewKey}  onBlur={this.clearInput} />
							) : (
								<Tag className="site-tag-plus" onClick={this.showInput2}>
									<PlusOutlined /> 关键字
								</Tag>
							)
						}
								
	        		</PageHeader>


	        		<PageHeader title="Comments" style={{paddingLeft:0,paddingRight:0}} 
	        			extra={[
							<Button key="1" type="primary" onClick={this.openCommentModal} >添加评论</Button>,
						]}
	        		>
	        			{
	        				this.state.variant['comments'] && this.state.variant['comments'].map((item,index) => {
	        					return <div style={{border:'1px solid #f0f0f0','paddingRight':'16px','paddingLeft':'16px'}}>
	        						<Comment content={item['comment']} author={item['email']} datetime={item['date']} avatar={<UserOutlined />}  />
	        					</div>
	        				})
	        			}
	        		</PageHeader>

				</div>
				<Modal
		        	title={<BuildTitle visible={this.state.add_comment_modal} id="add_comment_modal" title="添加评论" />}
					visible={this.state.add_comment_modal}
					onCancel={this.closeCommentModal}
					onOk={this.addComment}
					maskClosable={false}
					destroyOnClose={true}
					afterClose={() => {
			            try {
							document.getElementById('add_comment_modal').style.transform = "translate(0px, 0px)";
						} catch (e) {}
					}}
				>
					<Form
						style={{marginTop:'0px'}}
						ref="add_comment"
						layout="horizontal"
						initialValues={{}}
						labelCol = {{ span: 4 }}
						wrapperCol = {{ span: 24 }}
						labelAlign="left"
					>
						<Form.Item name="comment" label="" rules={[{ required: true }]}>
							<Input.TextArea rows={5} />
						</Form.Item>
					</Form>
				</Modal>

				<Modal
		        	title={<BuildTitle visible={this.state.edit_modal} id="edit_modal" title="编辑HPO" />}
					visible={this.state.edit_modal}
					onCancel={this.closeEditModal}
					onOk={this.editHPO}
					maskClosable={false}
					destroyOnClose={true}
					afterClose={() => {
			            try {
							document.getElementById('edit_modal').style.transform = "translate(0px, 0px)";
						} catch (e) {}
					}}
				>
					<Form
						style={{marginTop:'0px'}}
						ref="edit_hpo"
						layout="horizontal"
						initialValues={{...this.state.hpo}}
						labelCol = {{ span: 4 }}
						wrapperCol = {{ span: 24 }}
						labelAlign="left"
					>
						<Form.Item name="name_chs" label="英文名称" rules={[{ required: true }]}>
							<Input />
						</Form.Item>
						<Form.Item name="name" label="中文名称" rules={[{ required: false }]}>
							<Input />
						</Form.Item>
						<Form.Item name="definition" label="英文描述" rules={[{ required: false }]}>
							<Input.TextArea rows={5} />
						</Form.Item>
						<Form.Item name="definition_chs" label="中文描述" rules={[{ required: false }]}>
							<Input.TextArea rows={5} />
						</Form.Item>
					</Form>
				</Modal>
				<Footer />
			</div>
		)
	}
}